import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { updateBlueprint, deleteBlueprint } from 'events/blueprints';
import { Button, Grid, Header, Label, Confirm } from 'semantic-ui-react';
import InputField from 'common/InputField';
import IconEdit from './IconEdit';
import ScriptEditor from './ScriptEditor';
import ItemEditor from './ItemEditor';
import MapEditor from './MapEditor';
import TrapEditor from './TrapEditor';
import SkillEditor from './SkillEditor';
import SpellEditor from './SpellEditor';
import CreatureEditor from './CreatureEditor';
import QuestLogEditor from './QuestLogEditor';

const typeEditor = function(blueprint, change, all) {
  switch (blueprint._type) {
    case 'Script':
      return (
        <Grid.Row>
          <Grid.Column width={16}>
            <ScriptEditor src={blueprint.FileLua} onSave={change('FileLua')} />
          </Grid.Column>
        </Grid.Row>
      );
    case 'Item':
      return <ItemEditor item={blueprint} onChange={change} />
    case 'Map':
      return <MapEditor map={blueprint} onChange={change} blueprints={all} />
    case 'Trap':
      return <TrapEditor trap={blueprint} onChange={change} />
    case 'Skill':
      return <SkillEditor skill={blueprint} onChange={change} />
    case 'Spell':
      return <SpellEditor spell={blueprint} onChange={change} />
    case 'Creature':
      return <CreatureEditor creature={blueprint} onChange={change} blueprints={all} />
    case 'QuestLog':
      return <QuestLogEditor questlog={blueprint} onChange={change} />
    default:
      return '';
  }
}

const BlueprintEditor = function(props) {
  const orig = props.blueprints.find((bp) => props.id === bp.ID);

  const [ blueprint, setBlueprint ] = useState(orig);
  const [ deleteShown, setDeleteShown ] = useState(false);

  useEffect(() => {
    setBlueprint(orig);
  }, [props.id, orig]);

  if (!blueprint) {
    return <div className={props.className} />;
  }

  const idIsUnique = !props.blueprints.find((b) => b.ID === blueprint.ID);

  const updateField = (name, val) => {
    const bp = {...blueprint};
    bp[name] = val;
    setBlueprint(bp);
  };
  const change = (name) => (val) => updateField(name, val);

  const saveChanges = () => {
    props.update(props.id, blueprint);
    props.onSelectBlueprint(blueprint);
  }

  const revert = () => {
    setBlueprint(orig);
  };

  const deleteThisBlueprint = () => {
    setDeleteShown(false);
    props.onSelectBlueprint({});
    props.delete(props.id);
  };

  const typeSpecificEditor = typeEditor(blueprint, change, props.blueprints);


  return (
    <Grid stackable
          padded={true}
          className={props.className}>
      <Grid.Row textAlign='center'>
        <Grid.Column width={16}>
          <Header>Properties of <Label>{props.id}</Label> ({blueprint._type})</Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row verticalAlign='bottom'>
        <Grid.Column width={16}>
          <InputField placeholder='ID'
                      label='ID'
                      value={blueprint.ID}
                      onChange={change('ID')}
                      type='id' />
          <IconEdit icon={blueprint.Icon} onChange={change('Icon')} />
          <InputField placeholder='Name'
                      label='Name'
                      value={blueprint.Name}
                      onChange={change('Name')} />
        </Grid.Column>
      </Grid.Row>
      {typeSpecificEditor}
      <Grid.Row>
        <Grid.Column width={4}>
          <Button negative
                  onClick={() => setDeleteShown(true)}>
            Delete {props.id}
          </Button>
        </Grid.Column>
        <Grid.Column width={12} textAlign='right'>
          <Confirm content={'Are you sure you want to delete blueprint with id ' + props.id + '?'}
                   cancelButton='No, do not delete'
                   confirmButton='Yes, delete'
                   onCancel={() => setDeleteShown(false)}
                   onConfirm={deleteThisBlueprint}
                   open={deleteShown} />
          <Button onClick={revert}>
            Revert changes
          </Button>
          <Button primary
                  onClick={saveChanges}
                  disabled={((!idIsUnique) || blueprint.ID.length < 4) && blueprint.ID !== props.id}>
            Save changes
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}



const mapState = function(state) {
  return {
    blueprints: state.module.Blueprints
  }
}

const mapDispatch = function(dispatch) {
  return {
    update: (id, props) => dispatch(updateBlueprint(id, props)),
    delete: (id) => dispatch(deleteBlueprint(id))
  }
}

const ConnectedBlueprintEditor = connect(mapState, mapDispatch)(BlueprintEditor);

export default ConnectedBlueprintEditor
